export const LISTEN_INTERNAL_NOTES = "internalNotes/LISTEN_INTERNAL_NOTES";
export const CREATE_INTERNAL_NOTE = "internalNotes/CREATE_INTERNAL_NOTE";
export const DELETE_INTERNAL_NOTE = "internalNotes/DELETE_INTERNAL_NOTE";
